/**
 * @Author: Li, Yu Jia
 * @Date: 2020-07-27 11:10:24
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-07-27 13:27:38
 */

import { ACTION_EDITCARTUPSELLS, PARAMETER_RETURNURL, PARAMETER_STATUS, PARAMETER_VENDORID } from '../main/constants';
import { loadParameters, saveParameters } from './localStore';

import { INITIALIZE_PARAMETERS } from '../main/actions';

function createDataMiddleware(_extraArgument) {
  return () => (next) => (action) => {
    if (INITIALIZE_PARAMETERS === action.type) {
      const previousParas = loadParameters();
      const currentParas = action.payload;
      if (
        currentParas &&
        currentParas[PARAMETER_STATUS] &&
        currentParas[PARAMETER_STATUS].toLowerCase() === ACTION_EDITCARTUPSELLS
      ) {
        if (
          !previousParas ||
          previousParas[PARAMETER_STATUS] !== currentParas[PARAMETER_STATUS] ||
          previousParas[PARAMETER_VENDORID] !== currentParas[PARAMETER_VENDORID]
        ) {
          saveParameters({
            [PARAMETER_STATUS]: currentParas[PARAMETER_STATUS],
            [PARAMETER_VENDORID]: currentParas[PARAMETER_VENDORID],
          });
        }
      } else if (
        currentParas &&
        (!previousParas ||
          previousParas[PARAMETER_VENDORID] !== currentParas[PARAMETER_VENDORID] ||
          previousParas[PARAMETER_RETURNURL] !== currentParas[PARAMETER_RETURNURL] ||
          previousParas[PARAMETER_STATUS] !== currentParas[PARAMETER_STATUS])
      ) {
        saveParameters({
          [PARAMETER_VENDORID]: currentParas[PARAMETER_VENDORID],
          [PARAMETER_RETURNURL]: currentParas[PARAMETER_RETURNURL],
          [PARAMETER_STATUS]: currentParas[PARAMETER_STATUS],
        });
      }
    }
    return next(action);
  };
}

const localStoreMiddleware = createDataMiddleware();
localStoreMiddleware.withExtraArgument = createDataMiddleware;

export default localStoreMiddleware;
